import React from 'react';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Stats from './components/Stats';
import Minerals from './components/Minerals';
import Services from './components/Services';
import About from './components/About';
import Testimonials from './components/Testimonials';
import Contact from './components/Contact';
import Footer from './components/Footer';
import Icons from './components/Icons';
import './App.css';

function App() {
	return (
		<div className="min-h-screen">
			<Navbar />
			<Hero />
			<Stats />
			<Minerals />
			<Services />
			<About />
			<Testimonials />
			<Contact />
			<Footer />
			<a href="https://wa.me/51987654321" target="_blank" rel="noopener noreferrer" className="fixed bottom-6 right-6 w-14 h-14 bg-green-500 rounded-full flex items-center justify-center text-white shadow-lg shadow-green-500/40 hover:scale-110 transition-transform z-50 pulse-glow">
				<Icons.WhatsApp />
			</a>
		</div>
	);
}

export default App;
